'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { X, Check } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const diffs = [
{
  before: 'Chỉ "tham gia"',
  after: 'Trực tiếp "tạo ra giá trị"',
  desc: 'Không đứng nhìn — sinh viên là người trực tiếp thực hiện và sở hữu kết quả'
},
{
  before: 'Không có sản phẩm cụ thể',
  after: 'Có sản phẩm thực tế sau chương trình',
  desc: 'Khu trải nghiệm xanh được xây dựng, dọn sạch, và sử dụng lâu dài'
},
{
  before: 'Chứng nhận chỉ là giấy tờ',
  after: 'Chứng nhận + nội dung truyền thông',
  desc: 'Green Warrior Certificate kèm video, hình ảnh, câu chuyện cá nhân có thể chia sẻ'
},
{
  before: 'Trải nghiệm hời hợt',
  after: 'Trải nghiệm sâu + cảm xúc thật',
  desc: 'Từ lúc chạm vào vấn đề thật đến khi nhìn thấy kết quả — hành trình đủ sâu để nhớ mãi'
}];


export default function Slide05Difference({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0f2318]">
      <div className="absolute inset-0">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1d7b16549-1777290549940.png"
          alt="Tình nguyện viên sinh viên dọn dẹp rác ven hồ, hoạt động bảo vệ môi trường thực tế"
          className="w-full h-full object-cover opacity-10" />

        <div className="absolute inset-0 bg-gradient-to-tl from-[#1a3a2a]/50 via-[#0f2318] to-[#0f2318]" />
        <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-[rgba(232,160,48,0.04)] blur-3xl" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge">Điểm khác biệt</div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            Điểm khác biệt
          </h2>
          <h2 className="font-display font-800 text-[clamp(28px,4.5vw,56px)] leading-[1.1] tracking-tight text-gradient-green">
            của Tri An Green Travel
          </h2>
        </div>

        <div className="fade-in-up mb-10">
          <div className="section-divider" />
        </div>

        <div className="grid grid-cols-1 gap-4 fade-in-up">
          {diffs.map((diff, i) =>
          <div
            key={`diff-${i}`}
            className="rounded-2xl p-5 lg:p-6 bg-[rgba(26,58,42,0.4)] border border-[rgba(76,175,125,0.15)] transition-all duration-300 hover:-translate-y-0.5">

              <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-3 items-center mb-3">
                <div className="flex items-center gap-2.5 px-4 py-2.5 rounded-xl bg-[rgba(255,80,80,0.08)] border border-[rgba(255,80,80,0.15)]">
                  <X size={14} className="text-[#ff6060] flex-shrink-0" />
                  <span className="font-body text-[13px] lg:text-[14px] text-[#ff9090]">{diff.before}</span>
                </div>
                <div className="hidden md:flex items-center justify-center">
                  <span className="text-[#a0b8a8] text-[18px]">→</span>
                </div>
                <div className="flex items-center gap-2.5 px-4 py-2.5 rounded-xl bg-[rgba(76,175,125,0.1)] border border-[rgba(76,175,125,0.25)]">
                  <Check size={14} className="text-[#4caf7d] flex-shrink-0" />
                  <span className="font-body text-[13px] lg:text-[14px] text-[#4caf7d] font-600">{diff.after}</span>
                </div>
              </div>
              <p className="font-body text-[13px] text-[#a0b8a8] leading-relaxed pl-1">{diff.desc}</p>
            </div>
          )}
        </div>
      </div>
    </SlideWrapper>);

}